"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
var defaultEffect = {
    normal: 'background-image: none;',
    hover: 'background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2));',
    active: 'background-image: linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.25));',
    focus: 'box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .5);',
};
exports.buttonTheme = function (theme) {
    var componentTheme = {
        default: {
            color: {
                background: theme.greyLight.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.greyNormal.color.text,
                effect: {
                    normal: 'background-image: none;',
                    hover: 'background-image: linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.1));',
                    active: "\n            background-image: linear-gradient(rgba(0,0,0,0.15), rgba(0,0,0,0.15)); \n            border: 2px solid " + theme.greyDark.color.normal + "\n            ",
                    focus: 'box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .5);',
                },
            },
            border: "1px solid " + theme.greyNormal.color.normal,
        },
        primary: {
            color: {
                background: theme.primary.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.primary.color.text,
                effect: defaultEffect,
            },
            border: 'none',
        },
        secondary: {
            color: {
                background: theme.secondary.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.secondary.color.text,
                effect: defaultEffect,
            },
            border: 'none',
        },
        error: {
            color: {
                background: theme.error.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.error.color.text,
                effect: defaultEffect,
            },
            border: 'none',
        },
        warning: {
            color: {
                background: theme.warning.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.warning.color.text,
                effect: defaultEffect,
            },
            border: 'none',
        },
        success: {
            color: {
                background: theme.success.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.success.color.text,
                effect: defaultEffect,
            },
            border: 'none',
        },
        info: {
            color: {
                background: theme.info.color.normal,
                disabled: theme.greyNormal.color.normal,
                text: theme.info.color.text,
                effect: defaultEffect,
            },
            border: 'none',
        },
        size: {
            large: '15px',
            medium: '13px',
            small: '11px',
        },
        height: {
            large: '44px',
            medium: '36px',
            small: '28px',
        },
        borderRadius: theme.global.borderRadius,
    };
    if (theme.component.button) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.button);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { button: componentTheme }) });
};
exports.default = exports.buttonTheme;
//# sourceMappingURL=theme.js.map